import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import ConfigManager from '../../common/configManager/configManager';
import { HeaderWrapper, CentralWrapper, CentralInternalWrapper, HeaderShadow, ContentWrapper } from './styles';
import TeamBigLogo from '../shared/TeamBigLogo';
import TeamLogo from '../shared/TeamLogo';
import Label from '../shared/Label';
import IconFont from '../../components/shared/IconFont';

const imageMap = {
  5861: 1,
  4911: 1,
  1: 1,
  2761: 2,
  1781: 2,
  37: 2,
  33: 2,
  7061: 2,
  7051: 2,
  2: 2,
  10361: 2,
  14: 3,
  3: 3,
  17: 4,
  6901: 4,
  4821: 4,
  4301: 4,
  24: 4,
  8351: 4,
  8561: 4,
  4: 4,
  7691: 5,
  21: 5,
  8121: 5,
  29: 5,
  36: 5,
  6311: 5,
  5011: 5,
  161: 5,
  4971: 5,
  6881: 5,
  7931: 5,
  3961: 5,
  7121: 5,
  3821: 5,
  7941: 5,
  5: 5,
  4011: 331,
  331: 331,
  4791: 6,
  8551: 6,
  8581: 6,
  6: 6,
  6861: 22,
  39: 22,
  4941: 22,
  104: 22,
  8201: 22,
  4351: 22,
  8211: 22,
  5001: 22,
  7521: 22,
  8191: 22,
  79: 22,
  162: 22,
  4141: 22,
  22: 22,
  9201: 22,
  7081: 20,
  52: 20,
  53: 20,
  5511: 20,
  2741: 20,
  2911: 20,
  6281: 20,
  2961: 20,
  8171: 20,
  2751: 20,
  8181: 20,
  103: 20,
  8471: 20,
  20: 20,
  101: 19,
  19: 19,
  5641: 501,
  501: 501,
  46: 15,
  15: 15,
  18: 8,
  6481: 8,
  8111: 8,
  28: 8,
  30: 8,
  8: 8,
  8571: 8,
  9491: 8,
  9191: 8,
  102: 61,
  61: 61,
};

class DriverHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  getLogo = (id, compId, teamId) => {
    const isSectionScuderie = window.section_lev2 === 'scuderie';
    let imageLink = '';
    const motoConstructorUrl = ConfigManager.getMotorSportConstructor();
    const raceCompetitionName = {
      1: 'f1',
      2: 'superbike',
      3: 'motogp',
      4: 'moto3',
      5: 'moto2',
    };
    // Added switch to select new logos for Scuderie Section (teamId_n.png)
    switch (id) {
      case '6C':
        if ((teamId === 2 || teamId === 3 || teamId === 4) && isSectionScuderie) {
          imageLink = `${motoConstructorUrl}${raceCompetitionName[compId]}/${this.props.headerInfo.teamId}_n.png`;
        } else {
          imageLink = `${motoConstructorUrl}${raceCompetitionName[compId]}/${this.props.headerInfo.teamId}.png`;
        }
        break;
      case '6M':
        imageLink = `${motoConstructorUrl}${raceCompetitionName[compId]}/${imageMap[this.props.headerInfo.teamId]}.png`;
        break;
      default:
        imageLink = `//images2.gazzettaobjects.it/assets-mc/motori/teams/${this.props.dictionary[compId]}/${this.props.headerInfo.teamId}.png`;
        break;
    }
    return imageLink;
  };

  teamNameMapping = (teamId, teamName) => {
    switch (teamId) {
      case 4 || '4':
        return 'Ferrari';
      case 2 || '2':
        return 'Mercedes F1';
      case 3 || '3':
        return 'Red Bull';
      default:
        return teamName;
    }
  }

  render() {
    const {
      headerInfo,
      isMobile,
      competitionId,
      sportId,
      newspaper,
    } = this.props;
    const isGazzetta = newspaper === 'gazzetta';
    const isSectionScuderie = window.section_lev2 === 'scuderie';
    if (!isSectionScuderie) {
      return (
        <Row>
          <span
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              margin: '10px 0px 0px 15px',
            }}
          >
            <IconFont
              className="icon-matchcenter-back-arrow"
              color="black"
              font={26}
              onClick={() => window.history.back(-1)}
              withCursor
              marginLeft={isMobile ? 0.3 : 0}
            />
          </span>
          <Col
            lg={12}
            md={12}
            sm={12}
          >
            {headerInfo && headerInfo.teamId &&
              <HeaderWrapper
                className={`teamId-${headerInfo.teamId}`}
              >
                <TeamBigLogo
                  image={this.getLogo(sportId, competitionId, headerInfo.teamId)}
                  isDriver
                />
                <Col
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  offset={{
                    lg: 3, md: 2, sm: 2, xs: 1,
                  }}
                  style={{
                    justifyContent: 'center',
                    display: 'flex',
                    paddingLeft: isMobile ? '0px' : '',
                    paddingRight: isMobile ? '0px' : '',
                    marginLeft: isMobile ? '0px' : '25%',
                  }}
                >
                  <CentralWrapper
                    justifyContent={sportId === '6C' ? 'center' : ''}
                  >
                    <h1
                      style={{
                        color: 'white',
                        fontSize: isMobile ? '2em' : '3em',
                        fontFamily: props => (props.theme.fontSets.narrowMedium),
                        margin: '0px',
                        lineHeight: '1',
                        textAlign: 'center',
                      }}
                    >
                      {this.teamNameMapping(headerInfo.teamId, headerInfo.team)}
                    </h1>
                    { sportId !== '6C' &&
                    <CentralInternalWrapper>
                      <Label
                        label={`${headerInfo.teamEngine}`}
                        size={isMobile ? 1 : 1.1}
                        color="white"
                        isTitleNarrowRegular
                        uppercase
                        margin={isMobile ? '2px 0px' : '0px'}
                      />
                      {!isMobile &&
                        <Label
                          label="|"
                          size={isMobile ? 0.85 : 1.1}
                          color="white"
                          isTitleNarrowRegular
                          margin={isMobile ? '0em 0 0' : '0em 0.2em 0 0.2em'}
                        />
                      }
                      <Label
                        label={`${headerInfo.teamCarBike}`}
                        size={isMobile ? 0.85 : 1.1}
                        color="white"
                        isTitleNarrowRegular
                        margin={isMobile ? '2px 0px' : '0px'}
                      />
                    </CentralInternalWrapper>
                    }
                    {sportId !== '6M' &&
                      <CentralInternalWrapper>
                        <Label
                          label={`Punti: ${headerInfo.points}`}
                          size={isMobile ? 0.85 : 1.1}
                          color="white"
                          isTitleNarrowRegular
                          margin={isMobile ? '3px 0px' : '0px'}
                        />
                        {!isMobile &&
                        <Label
                          label="|"
                          size={isMobile ? 0.85 : 1.1}
                          color="white"
                          isTitleNarrowRegular
                          margin={isMobile ? '0em 0 0' : '0em 0.2em 0 0.2em'}
                        />
                        }
                        <Label
                          label={`Posizione in classifica: ${headerInfo.position}`}
                          size={isMobile ? 0.85 : 1.1}
                          color="white"
                          isTitleNarrowRegular
                          margin={isMobile ? '3px 0px' : '0px'}
                        />
                        {!isMobile &&
                        <Label
                          label="|"
                          size={isMobile ? 0.85 : 1.1}
                          color="white"
                          isTitleNarrowRegular
                          margin={isMobile ? '0em 0 0' : '0em 0.2em 0 0.2em'}
                        />
                        }
                        <Label
                          label={`Vittorie: ${headerInfo.victories}`}
                          size={isMobile ? 0.85 : 1.1}
                          color="white"
                          isTitleNarrowRegular
                          margin={isMobile ? '3px 0px' : '0px'}
                        />
                      </CentralInternalWrapper>
                    }
                  </CentralWrapper>
                </Col>
                {!isMobile &&
                  <Col lg={3} md={2} sm={2} xs={2} />
                }
              </HeaderWrapper>
            }
          </Col>
        </Row>
      );
    } else {
      return (
        <Row>
          <span
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              margin: '10px 0px 0px 15px',
            }}
          >
            <IconFont
              className="icon-matchcenter-back-arrow"
              color="black"
              font={26}
              onClick={() => window.history.back(-1)}
              withCursor
              marginLeft={isMobile ? 0.3 : 0}
            />
          </span>
          <Col
            lg={12}
            md={12}
            sm={12}
          >
            {headerInfo && headerInfo.teamId &&
              <HeaderWrapper
                className={`teamId-${headerInfo.teamId}`}
                justifyContent="unset"
                alignItems="center"
              >
                <ContentWrapper
                  flex="0 0 30%"
                  display="flex"
                  justifyContent="center"
                >
                  <TeamLogo
                    image={this.getLogo(sportId, competitionId, headerInfo.teamId)}
                    isMobile={isMobile}
                    teamId={headerInfo.teamId}
                  />
                </ContentWrapper>
                <ContentWrapper
                  flex="1 1 auto"
                >
                  <h1
                    style={{
                      color: 'white',
                      fontSize: isMobile ? '2em' : '3em',
                      fontFamily: props => (props.theme.fontSets.narrowMedium),
                      margin: '0px',
                      lineHeight: '1',
                      textAlign: 'center',
                    }}
                  >
                    {this.teamNameMapping(headerInfo.teamId, headerInfo.team)}
                  </h1>
                </ContentWrapper>
                <ContentWrapper
                  flex="0 0 30%"
                />
                <HeaderShadow
                  isMobile={isMobile}
                  className="HeaderShadow"
                >
                  <div
                    className="matchcenter-widget"
                    data-widgettype="NextRaceWidget"
                    id="nextMatch"
                    data-competitionid={competitionId}
                    data-sportid={sportId}
                  />
                </HeaderShadow>
              </HeaderWrapper>
            }
          </Col>
        </Row>
      );
    }
  }
}

DriverHeader.propTypes = {
  headerInfo: PropTypes.any,
  dictionary: PropTypes.any,
  isMobile: PropTypes.bool,
  competitionId: PropTypes.any,
  sportId: PropTypes.string,
  newspaper: PropTypes.any,
};

export default DriverHeader;



// WEBPACK FOOTER //
// ./src/lib/components/DriverHeader/index.js